/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Research_Mock_FootInputs */

const en_cap_research_mock_foot = /** @type {(inputs: Cap_Research_Mock_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 sources, each one checked`)
};

const lv_cap_research_mock_foot = /** @type {(inputs: Cap_Research_Mock_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 avoti, katrs pārbaudīts`)
};

/**
* | output |
* | --- |
* | "4 sources, each one checked" |
*
* @param {Cap_Research_Mock_FootInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_research_mock_foot = /** @type {((inputs?: Cap_Research_Mock_FootInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Research_Mock_FootInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_research_mock_foot(inputs)
	return en_cap_research_mock_foot(inputs)
});